import { useQuery } from '@tanstack/react-query'
import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import { getRecentlyViewedProducts } from '~/lib/handle-api'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { useGlobalData } from '~/providers/GlobalDataProvider'

import useProductsRecentlyViewed from '~/hooks/useProductsRecentlyViewed'
import { ProductsViewedContext } from '~/hooks/useProductsRecentlyViewed/context'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type RecentlyViewedWrapperProps = {
  className?: string
  Component?: any
}

function RecentlyViewedWrapper({
  className,
  Component,
}: RecentlyViewedWrapperProps) {
  const { locale } = useRouter()
  const ProductViewedCtx = useContext(ProductsViewedContext)
  const { document } = useGlobalData()
  const uids = useProductsRecentlyViewed(locale, ProductViewedCtx)
    .filter((item) => {
      if (!document) return null
      if (document.type === STORYBLOK_TYPES.PRODUCT)
        return item !== `${STORYBLOK_TYPES.PRODUCT}/${document.uid}`
      else return item
    })
    .filter((item) => item)

  const { data: result, isLoading } = useQuery(
    ['products_recently_viewed', ...uids.map((item) => `${item}-${locale}`)],
    async () => {
      if (uids?.length > 0) {
        return getRecentlyViewedProducts({
          payload: { uids: uids.join(','), locale },
        })
      } else {
        return []
      }
    },
  )

  return (
    <Component
      items={result?.items ?? []}
      hasUuidsToFetch={uids?.length > 0}
      isLoading={isLoading}
      className={className}
    />
  )
}

RecentlyViewedWrapper.defaultProps = {}

export default RecentlyViewedWrapper
